import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgConstruct = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="m24.307 9.204-11.103-8.1a.89.89 0 0 0-1.054 0l-11.103 8.1a.901.901 0 0 0-.325 1.007l4.242 13.106c.12.371.465.621.852.621h13.725c.39 0 .731-.25.852-.621l4.242-13.106a.908.908 0 0 0-.328-1.007Zm-2.473.56-2.762.9-5.607-4.07V3.658l8.37 6.105Zm-10.447 4.224-2.498 3.44-1.547-4.76 4.045 1.32Zm-3.26-2.723 3.765-2.73v3.96l-3.765-1.23Zm4.55 3.623 2.633 3.625h-5.266l2.633-3.625Zm.788-6.354 3.763 2.731-3.763 1.227V8.534Zm.502 5.454 4.046-1.32-1.548 4.76-2.498-3.44Zm-2.075-10.33v2.936l-5.61 4.07-2.762-.9 8.372-6.106ZM3.07 11.277l2.425.79 2.254 6.93-1.508 2.078-3.171-9.798Zm4.424 10.749 1.41-1.94h7.55l1.411 1.94H7.493Zm11.622-.95-1.509-2.08 2.254-6.93 2.426-.79-3.171 9.8Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgConstruct)
const Memo = memo(ForwardRef)
export default Memo
